module.exports = __webpack_public_path__ + "img/rogue_side.ab572a2e.png";